import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Card, ListGroup } from "react-bootstrap";
import { RocketTakeoffFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

export default function Planos() {
    return (
        <section id="planos">
            <Container className="d-flex justify-content-center">
                <Card style={{ maxWidth: "400px" }} className="h-100 shadow-sm border-0">
                    <div style={{
                        background: "gold",
                        color: "black",
                        padding: "5px 0",
                        fontWeight: "bold"
                    }}>
                        PLANO ÚNICO
                    </div>
                    <Card.Body className="text-center">
                        <h2 className="fw-bold">R$ 600,00</h2>
                        <p className="text-muted">Pagamento único anual</p>
                        <hr />

                        <ListGroup variant="flush" className="text-start mb-4">
                            <ListGroup.Item><FontAwesomeIcon className="text-success pe-2" size="xl" icon={faCheckSquare} />
                                Emissão ilimitada de MDF-e
                            </ListGroup.Item>
                            <ListGroup.Item><FontAwesomeIcon className="text-success pe-2" size="xl" icon={faCheckSquare} />
                                Inclusão de condutores e documentos
                            </ListGroup.Item>
                            <ListGroup.Item><FontAwesomeIcon className="text-success pe-2" size="xl" icon={faCheckSquare} />
                                Encerramento e cancelamento rápido
                            </ListGroup.Item>
                            <ListGroup.Item><FontAwesomeIcon className="text-success pe-2" size="xl" icon={faCheckSquare} />
                                Impressão DAMDFE
                            </ListGroup.Item>
                            <ListGroup.Item><FontAwesomeIcon className="text-success pe-2" size="xl" icon={faCheckSquare} />
                                Suporte prioritário
                            </ListGroup.Item>
                        </ListGroup>

                        <Link to={'/register'} className="btn btn-primary"><RocketTakeoffFill className="me-2" />Assinar agora</Link>
                    </Card.Body>
                </Card>
            </Container>
        </section>
    );
}
